import { render, staticRenderFns } from "./related-content.vue?vue&type=template&id=30affa3c&"
import script from "./related-content.vue?vue&type=script&lang=js&"
export * from "./related-content.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports